<template>
  <el-dialog :title="$t('productCategory.editTitle')" :visible.sync="dialogVisible" width="50%" @close="closeDialog">
    <el-form ref="form" :model="formData" label-width="120px">
      <el-form-item :label="$t('productCategory.categoryName')" prop="categoryName" :rules="[
        { required: true, message: $t('productCategory.nameRequired'), trigger: 'blur' },
        { max: 100, message: $t('productCategory.nameMaxLength'), trigger: 'blur' }
      ]">
        <el-input v-model="formData.categoryName" :placeholder="$t('productCategory.namePlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('productCategory.showOrder')" prop="seq" :rules="[
        { required: true, message: $t('productCategory.orderRequired'), trigger: 'blur' },
      ]">
        <el-input v-model.number="formData.seq" :placeholder="$t('productCategory.orderPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('productCategory.isShow')" prop="isShow" :rules="[
        { required: true, message: $t('productCategory.showRequired'), trigger: 'change' }
      ]">
        <el-select v-model="formData.isShow" :placeholder="$t('productCategory.showPlaceholder')" style="width:100%">
          <el-option v-for="(item, index) in isShows" :key="index" :label="item.name" :value="item.statusCd" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('productCategory.groupType')" prop="cateType" :rules="[
        { required: true, message: $t('productCategory.groupRequired'), trigger: 'change' }
      ]">
        <el-select v-model="formData.cateType" :placeholder="$t('productCategory.groupPlaceholder')" style="width:100%">
          <el-option v-for="(item, index) in filteredCateTypes" :key="index" :label="item.name" :value="item.statusCd" />
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="updateProductCategory">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { updateProductCategory } from '@/api/goods/productCategoryApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditProductCategory',
  data() {
    return {
      dialogVisible: false,
      formData: {
        categoryId: '',
        categoryName: '',
        seq: '',
        isShow: '',
        cateType: '',
        parentCategoryId: '',
        categoryLevel: '',
        shopId: ''
      },
      isShows: [],
      cateTypes: []
    }
  },
  computed: {
    // 过滤掉积分商品（cateType 为 '3'）
    filteredCateTypes() {
      return this.cateTypes.filter(item => item.statusCd !== '3')
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.formData = { ...row }
      this.getDictData()
    },
    async getDictData() {
      try {
        const { data: isShows } = await getDict('product_category', 'is_show')
        this.isShows = isShows
        const { data: cateTypes } = await getDict('product_category', 'cate_type')
        this.cateTypes = cateTypes
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    closeDialog() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
    },
    async updateProductCategory() {
      try {
        await this.$refs.form.validate()
        let shopId = getShopId()
        this.formData.shopId = shopId
        await updateProductCategory(this.formData)
        this.$emit('refresh')
        this.$message.success(this.$t('common.submitSuccess'))
        this.closeDialog()
      } catch (error) {
        this.$message.error(error)
        console.error('更新失败:', error)
      }
    }
  }
}
</script>